<template>
  <div>
    <v-tour :name="name" :steps="steps" :options="options">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button @click="onDontShowTourAgain()" v-if="tour.isFirst" class="v-step__button"> {{$t("tours.buttons.dontShowAgain")}} </button>
                <button @click="tour.stop" v-if="!tour.isLast" class="v-step__button"> {{$t("tours.buttons.skipTour")}} </button>
                <!-- button @click="tour.previousStep" v-if="!tour.isFirst" class="v-step__button"> {{$t("tours.buttons.previous")}} </button -->
                <button @click="tour.nextStep" v-if="!tour.isLast" class="v-step__button"> {{$t("tours.buttons.next")}} </button>
                <button @click="tour.stop" v-if="tour.isLast" class="v-step__button"> {{$t("tours.buttons.finish")}} </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-btn style="position:fixed; bottom:10px; right:10px;" :color="darkMode ? 'secondary' : 'primary'" fab small @click="onTourClicked()">
      <v-icon>help_outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
import UserService from "../../services/user.service";

export default {
  name: 'Tour',
  props:{
    name: {
      type: String,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    options:{
      type: String,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark;
    },
  },
  methods:{
    onTourClicked(){
      this.$tours[this.name].start()
    },
    onDontShowTourAgain(){
      this.$tours[this.name].stop();
      UserService.switchShowTour(this.currentUser.id, false);
      this.$store.dispatch("auth/setShowTour", false);
    }
  }
}
</script>

<style>
  .v-tour__target--highlighted {
    box-shadow: 0 0 0 99999px rgba(0,0,0,.3) !important;
  }
</style>
